import { Directive, ElementRef, EventEmitter, Output } from '@angular/core';
import * as $ from 'jquery';

@Directive({
  selector: '[appDropzone]'
})
export class DropZoneDirective {
  @Output() UploadEvent: EventEmitter<any> = new EventEmitter();

  constructor(private el: ElementRef) {
    $(el.nativeElement).off('drag dragstart dragend dragover dragenter dragleave drop');
    $(el.nativeElement)
      .on('drag dragstart dragend dragover dragenter dragleave drop', function (e: any) {
        e.preventDefault();
        e.stopPropagation();
      })
      .on('dragover dragenter', function () {
        $(this).addClass('is-dragover');
      })
      .on('dragleave dragend drop', function () {
        $(this).removeClass('is-dragover');
      })
      .on('drop', function (evt: any) {
        evt.stopPropagation();
        evt.preventDefault();

        const files = evt.originalEvent.dataTransfer.files;

        if (files.length > 0) {
          this.UploadEvent.emit(files[0]);
        }
      });
  }
}
